import compose from './compose';

if (document.querySelector('#js-message-compose')) {
  compose();
}
